import React, {Component} from 'react';
import {Breadcrumb, Button, Popup} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {Helmet} from "react-helmet";

import ProductData from "../../data/ProductData";

import CustomDivider from '../../components/extras/CustomDivider';
import ProductDialog from "../../components/inventories/ProductDialog";
import ProductComboDialog from "../../components/inventories/ProductComboDialog";
import ProductImagesDialog from "../../components/inventories/ProductImagesDialog";
import CurrentStockModal from "../../components/inventories/CurrentStockModal";
import {connect} from "react-redux";
import localDB from "../../data/localDB";
import DynamicTable from "../../components/extras/DynamicTable";
import {productDialog} from "../../actions/ProductDialogActions";
import {dynamicTableAddOrUpdate, dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import QuestionDialog from "../../components/extras/QuestionDialog";
import {showToast} from "../../actions/ToastAction";
import {selectProduct} from "../../actions/ProductSelectActions";
import ProductType from "../../components/inventories/ProductType";
import ProductStock from "../../components/inventories/ProductStock";
import {showAlert} from "../../actions/AlertAction";
import ProductCompoundDialog from "../../components/inventories/ProductCompoundDialog";
import {productRecipesDialog} from "../../actions/ProductRecipesDialogActions";
import ProductVariantsDialog from "../../components/inventories/ProductVariantsDialog";
import {productPricesDialog} from "../../actions/ProductPricesDialogActions";
import ProductPricesDialog from "../../components/inventories/ProductPricesDialog";
import helpers from "../../functions/helpers";
import AdditionsDialog from "../../components/inventories/AdditionsDialog";
import Auth from "../../data/auth";
let GLOBAL = require('../../data/globals');

class Products extends Component {
    constructor(props) {
        super(props);

        let more_actions = [
            this.buttonCompounds,
            this.buttonAdditions,
            this.buttonPrices
        ]

        let other_actions_components =[
            this.buttonDownloadProductList
        ]

        this.state = {
            table: {
                headers: ['Producto', 'Precio Compra', 'Precio Venta', 'Tipo', 'Inventario', 'Acciones'],
                name: 'Producto',
                title: 'Productos',
                has_actions: true,
                edit: true,
                images: true,
                can_add: true,
                pagination: true,
                delete: true,
                url: 'products',
                search: {active:true},
                values: ['id', 'name', 'purchase_price', 'sale_price', 'product_type', 'stock'],
                component_fields:[{product_type: ProductType, stock:ProductStock}],
                money_fields: ['purchase_price', 'sale_price'],
                id: 'table_products',
                search_fields: [
                    {id:'name', name:'nombre', type:'text', is_main:true},
                    {id:'barcode', name:'código de barras', type:'text', is_main:false},
                    {id:'active', name:'estado', type:'list', values:[{'text': 'Activo', value:true}, {'text': 'Inactivo', value:false}], is_main:false},
                ],
                other_actions_components: other_actions_components,
                more_actions: more_actions
            },
            downloading_list: false
        };
        this.delete = this.delete.bind(this);
        this.buttonCompounds = this.buttonCompounds.bind(this);
        this.additions_dialog = React.createRef();
    }

    downloadProductsList = () =>{
        this.setState({downloading_list:true});
        Auth.tokenUID().then(res => {
            if(res.token){
                let link =   document.createElement("a");
                link.download = 'download';
                link.href = `${GLOBAL.BASE_URL}api/reports/products/excel?token=${res.token}&uid=${res.uid}&`;
                link.click();
            }
        }).catch((error) => console.log(error))
            .finally(() => { this.setState({downloading:false}); });
    };

    buttonDownloadProductList = () => {
        return <div style={{margin:6}}>
            <Button fluid icon='file excel outline' disabled={this.state.downloading_list} loading={this.state.downloading_list} content='Descargar lista de productos' onClick={this.downloadProductsList}/>
        </div>;
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.product_select && nextProps.product_select.hasOwnProperty('id')){
            this.props.dynamicTableAddOrUpdate(nextProps.product_select);
        }
    }

    buttonCompounds = (data) => {
        return <Popup
            trigger={<Button icon='balance scale' onClick={()=>this.showRecipes(data)}/>}
            content='Componentes'
            position='top left'
            key={helpers.generate_token()}
        />;
    }

    buttonPrices = (data) => {
        return !localDB.get('plan_access')['access_exclude'].includes('warehouse') ? <Popup
            trigger={<Button icon='money bill alternate' onClick={()=>this.props.productPricesDialog({id: data.id, name: data.name, is_open:true})}/>}
            content='Precios'
            position='top left'
            key={helpers.generate_token()}
        />:null;
    }

    buttonAdditions = (data) => {
        return <Popup
            trigger={<Button icon='bar' onClick={()=>this.additions_dialog.current.handleOpen(data)}/>}
            content='Adicionales'
            position='top left'
            key={helpers.generate_token()}
        />;
    }

    showRecipes = (data) => {
        this.props.productRecipesDialog({id: data.id, name: data.name, is_open:true});
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.productDialog({
                open: true, product: {
                    id: null,
                    name: '',
                    sale_price: 0,
                    purchase_price: 0,
                    tax_price: 0,
                    category: null,
                    provider: null,
                    tax: null,
                    active: true,
                    visible: false,
                    product_type: '',
                    stock: false
                }
            });
        }else if(response.event === 'edit'){
            this.props.productDialog({open:true, product:response.data, is_variant:false, variant_parent:null});
        }else if(response.event === 'delete'){
            this.refs.deleteDialog.open('', response.data.id);
        }else if(response.event === 'images'){
            this.refs.dialogImages.loadData(response.data.name, response.data.id);
        }
    };

    async delete(id) {
        ProductData.delete(id, (res) => {
            if (res === null) {
                this.props.showToast({message: 'Producto borrado!', type: 'success'});
                this.props.dynamicTableDelete(id);
                localDB.deleteDB('products', id);
            } else {
                this.props.showToast({message: 'El producto está siendo utilizado!', type: 'error'});
            }
        });
    };

    render() {

        return (
            <div>
                <Helmet>
                    <title>Productos | Invetarios - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/inventories'>Inventarios</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Productos</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <ProductDialog/>
                <ProductImagesDialog ref="dialogImages"/>
                <ProductComboDialog />
                <AdditionsDialog ref={this.additions_dialog}/>
                <ProductCompoundDialog />
                <ProductPricesDialog />
                <ProductVariantsDialog />
                <QuestionDialog ref="deleteDialog" message="Borrar este producto" callbackConfirm={this.delete}/>
                <CurrentStockModal />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        product_select: state.get('product_select'),
    };
}

function mapDispatchToProps(dispatch){
    return {
        productDialog(data){
            dispatch(productDialog(data))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
        showToast(data){
            dispatch(showToast(data))
        },
        showAlert(data){
            dispatch(showAlert(data))
        },
        selectProduct(data) {
            dispatch(selectProduct(data))
        },
        productRecipesDialog(modal) {
            dispatch(productRecipesDialog(modal))
        },
        productPricesDialog(modal) {
            dispatch(productPricesDialog(modal))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Products)



// WEBPACK FOOTER //
// ./src/containers/inventories/Products.js